import { useCallback, useEffect, useMemo, useState } from 'react';
import { getBuilds, startBuild } from './apiService';
import moment from 'moment';
import { toast } from 'react-toastify';
import LoadingOverlay from '../../extras/LoadingOverlay';
import WebsiteTable from './utils/table';
import { PageHeader } from '../../extras/PageLayout';

export default function BuildWebsite() {
  const [data, setData] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const [startBuilding, setStartBuilding] = useState(false);
  async function getInitialBuilds() {
    try {
      setListLoading(true);
      const response = await getBuilds();
      if (response.successful) setData(response.jobSummaries);
      else toast.error(response.message);
    } catch (e) {
      console.error(e);
      toast.error('Internal Server Error');
    } finally {
      setListLoading(false);
    }
  }
  useEffect(() => {
    getInitialBuilds();
  }, []);

  const onRefreshButtonClicked = useCallback(() => {
    getInitialBuilds();
  }, []);

  const onStartBuildClicked = useCallback(async () => {
    try {
      setStartBuilding(true);
      const response = await startBuild();
      if (response.successful) setData([response.jobSummary, ...data]);
      else toast.error(response.message);
    } catch (e) {
      console.error(e);
      toast.error('Internal Server Error');
    } finally {
      setStartBuilding(false);
    }
  }, [data]);

  const rowData = useMemo(() => {
    return data.map((d) => ({
      ...d,
      commitMessage: d.commitMessage || d.commitId,
      startTimeAgo: d.startTime && moment(d.startTime).fromNow(),
      buildTime:
        d.startTime &&
        d.endTime &&
        `${moment(d.endTime).diff(moment(d.startTime), 'minutes')} minutes`,
    }));
  }, [data]);
  return (
    <div className='relative'>
      {(listLoading || startBuilding) && <LoadingOverlay />}
      <PageHeader
        title="AlmaBetter Website"
        subtitle="Manage website builds and deployments"
        actions={
          <>
            <button
              className='px-4 py-2 rounded-md text-sm font-semibold transition-all duration-150 cursor-pointer'
              style={{
                backgroundColor: 'transparent',
                color: 'var(--text-secondary)',
                border: '1px solid var(--border-main)',
              }}
              onClick={onRefreshButtonClicked}
              disabled={listLoading}
            >
              Refresh List
            </button>
            <button
              className='px-4 py-2 rounded-md text-sm font-semibold transition-all duration-150 cursor-pointer'
              style={{
                backgroundColor: startBuilding ? 'var(--text-disabled)' : 'var(--primary-main)',
                color: 'var(--primary-contrast)',
                border: 'none',
                cursor: startBuilding ? 'not-allowed' : 'pointer',
              }}
              disabled={startBuilding}
              onClick={onStartBuildClicked}
            >
              {startBuilding ? 'Building...' : 'Start Build'}
            </button>
          </>
        }
      />
      <WebsiteTable rowData={rowData} />
    </div>
  );
}
